<template>
    <form @submit.prevent="submit" class="login" @change="validate($event.target.name)">
        <div class="selected">
            بازیابی گذرواژه
        </div>

        <the-input v-model="data.email" type="text" :align="data.email? 'left' : 'right'"
                   :invalid-text="state.error.email" placeholder="ایمیل" name="email"/>

        <vue-recaptcha class="d-flex-r-ac-g1-s1" sitekey="6LezA0gcAAAAAGAcICq898569tI4DMHOfiYos_oo" :key="theme" :size="theme"
                       theme="light" language="fa"
                       :loadRecaptchaScript="true" @verify="recaptcha=true" @expired="recaptcha=false"
                       @error="recaptcha=false"/>

        <the-button flat class="gradient-template-linear-pink" type="submit" :title="Object.values(state.error)">
            ارسال کد
        </the-button>
    </form>
</template>

<script>
    import TheInput from "@/components/Tools/TheInput";
    import VueRecaptcha from 'vue-recaptcha';
    import TheButton from "@/components/Tools/TheButton";

    const errorTemplate = {
        email: {
            required: true,
            regexName: 'email'
        },
    }

    export default {
        name: "ForgetPass",
        components: {TheButton, TheInput,VueRecaptcha},
        data() {
            return {
                data: {
                    email: '',
                    password: '',
                },
                recaptcha:false,
                theme:'normal'
            }
        },
        methods: {
            async submit() {
                if (await this.$validate(this.data, errorTemplate) && this.recaptcha) {
                    this.$cookies.set('username', this.data.email)
                    this.state.userInfo.email = this.data.email
                    this.$push({name: 'ResetPass',params:{pathMatch:'EMAIL'}})
                }
            },
            validate(key) {
                let data = {}
                data[key] = this.data[key]
                this.$validate(data, errorTemplate)
            }
        },
        beforeDestroy(){
            console.log(document.body.lastChild.remove())
        }
    }
</script>

<style lang="scss" scoped>
</style>